import React, { useEffect } from "react";
import { Search, Heart, User, ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import WhatsAppButton from "./WhatsAppButton";
import Footer from "./Footer";
import Header from "./Header";

const AboutUs = () => {
  const navigate = useNavigate();
useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 via-white to-purple-50">
      <Header />

      {/* Hero Section */}
      <div className="relative h-96 bg-gradient-to-r from-purple-900 to-purple-800 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDZkGS-kNqBg4qAguhFK_dgS7ffBPKYL70Ug&s')] opacity-20 bg-cover bg-center" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-purple-900 opacity-50" />
        <div className="relative container mx-auto px-6 h-full flex items-center">
          <div className="max-w-2xl text-white">
            <h1 className="text-5xl font-bold mb-4">Our Story</h1>
            <p className="text-xl text-purple-100">
              Crafting timeless elegance through generations of artisanal excellence
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-16">
        {/* Who We Are Section */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXrC2hjm_sG6omMHAzMvvP-fFTo4_xWFhhlQ&s"
              alt="Craftsmanship"
              className="w-full h-96 object-cover"
            />
          </div>
          <div className="bg-white rounded-xl shadow-md p-8 transition-all duration-300 hover:shadow-xl">
            <h2 className="text-3xl font-bold mb-6 text-purple-900">Who We Are</h2>
            <p className="text-purple-700 leading-relaxed mb-6">
              Welcome to Ambaari Jewels, where tradition meets contemporary elegance. 
              Our journey began with a passion for timeless beauty and exceptional 
              craftsmanship, offering pieces that combine centuries-old artisanal 
              techniques with modern sophistication.
            </p>
            <p className="text-purple-600 leading-relaxed">
              Each piece in our collection tells a unique story, crafted with meticulous 
              attention to detail and an unwavering commitment to quality.
            </p>
          </div>
        </div>

        {/* Our Vision Section */}
        <div className="text-center max-w-3xl mx-auto mb-20 bg-white rounded-xl shadow-md p-8 transition-all duration-300 hover:shadow-xl">
          <h2 className="text-3xl font-bold mb-6 text-purple-900">Our Vision</h2>
          <p className="text-purple-700 leading-relaxed">
            At Ambaari Jewels, we believe that jewelry is more than just an
            accessory—it's a reflection of personal style, cultural heritage, and
            life's most precious moments. Our vision is to create pieces that not
            only adorn but also inspire, celebrating the unique beauty in every
            individual.
          </p>
        </div>

        {/* Why Choose Us Section */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {[
            {
              title: "Authentic Craftsmanship",
              description:
                "Every piece is handcrafted by skilled artisans using traditional techniques",
            },
            {
              title: "Quality Assurance",
              description:
                "We use only the finest materials, ensuring lasting beauty and value",
            },
            {
              title: "Unique Designs",
              description:
                "Our collections blend traditional motifs with contemporary aesthetics",
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-102"
            >
              <h3 className="text-xl font-semibold mb-4 text-purple-900">{feature.title}</h3>
              <p className="text-purple-700">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="bg-white rounded-xl shadow-md p-12 transition-all duration-300 hover:shadow-xl">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6 text-purple-900">Get in Touch</h2>
            <p className="text-purple-700 mb-8">
              We're here to assist you in finding the perfect piece or answering
              any questions you may have about our collections.
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  title: "Visit Us",
                  content: "Ambaari jewels, # 34, Ground Floor, Shop No.4, LIC layout, Opp. century Indus Apartment, R R Nagar, Bangalore - 560098",
                },
                {
                  title: "Call Us",
                  content: "+91 8660891204",
                },
                {
                  title: "Email Us",
                  content: "ambaarijewels@gmail.com",
                },
              ].map((contact, index) => (
                <div key={index} className="p-6 bg-purple-50 rounded-lg shadow-sm hover:shadow-md transition-all duration-300">
                  <h3 className="font-semibold mb-2 text-purple-900">{contact.title}</h3>
                  <p className="text-purple-700">{contact.content}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default AboutUs;